var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M1.9,5A3.1,3.1,0,0,1,5,1.9H9V0H5A5,5,0,0,0,5,10H9V8.1H5A3.1,3.1,0,0,1,1.9,5ZM6,6h8V4H6Zm9-6H11V1.9h4a3.1,3.1,0,1,1,0,6.2H11V10h4A5,5,0,0,0,15,0Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }